/**
 * Cash transfers layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * Cash transfers are part of the 1.0-withheld `cash` module (returns in 1.2).
 * This layout route redirects a typed `/transfers` URL — and every nested child
 * (`/cash/transfers/new`, `/cash/transfers/$movementId`) — to `/` unless the workspace is
 * entitled to `cash`, which no 1.0 plan grants. (Distinct from
 * `/inventory/stock-transfers`, gated by `stock-ops`.) Renders only an `<Outlet/>`.
 * @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/cash/transfers")({
  beforeLoad: requireModule("cash"),
  component: Outlet,
});
